import apiClient from './apiClient'

/**
 * Fetch current campaigns for the user
 * @returns campaigns model
 */
export const getCampaigns = async () => await apiClient.get('/api/campaigns')